<script lang="ts">
export default {
    name: 'AppSupportChatDrawer',
};
</script>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { MODE } from '@/components/base-components/components/drawer/constants';
import useSupportChat from '@/composables/useSupportChat';
import { SUPPORT_CHAT_INLINE_ID } from '@/components/app/support-chat/constants';

// @ts-expect-error not typed yet
import { useAppSidebarStore } from '@/store/pinia/app/sidebar';

const {
    loading,
    mode,
    onDrawerClosed,
    visible,
} = useSupportChat();

const breakpoints = useBreakpoints(breakpointsTailwind);
const lgAndLarger = breakpoints.greaterOrEqual('lg');

const drawerMode = computed(() => lgAndLarger.value ? mode.value : MODE.OVERLAY);

const appSidebarStore = useAppSidebarStore();
const { collapsed } = storeToRefs(appSidebarStore);

watch(visible, (visible) => {
    if (!visible) return;
    if (drawerMode.value !== MODE.PERSISTENT) return;
    if (collapsed.value) return;

    appSidebarStore.toggle();
});
</script>

<template>
    <base-drawer
        v-model="visible"
        title="Support"
        size="md"
        :mode="drawerMode"
        :closable-overlay="drawerMode === MODE.OVERLAY"
        @closed="onDrawerClosed"
    >
        <template #header="{ close }">
            <div
                class="flex h-12 shrink-0 items-center bg-linear-to-r from-[#43363a] to-secondary-950 py-1 lg:before:h-full lg:before:w-px lg:before:bg-white/50"
            >
                <div class="flex flex-1 pr-2 pl-4">
                    <div class="flex flex-1 items-center justify-between gap-x-3 text-white">
                        <span
                            class="text-xl font-semibold whitespace-nowrap"
                        >
                            Support
                        </span>

                        <div class="flex items-center gap-x-2">
                            <div
                                class="cursor-pointer rounded-md p-1 text-white hover:bg-gray-700 active:bg-gray-600"
                                @click="close"
                            >
                                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     stroke="currentColor"
                                     aria-hidden="true"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template #content>
            <div
                class="flex min-h-0 flex-1 flex-col bg-white"
                v-loader="loading"
            >
                <div
                    :id="SUPPORT_CHAT_INLINE_ID"
                    class="h-full min-h-0 w-full flex-1 [&_iframe]:h-full [&_iframe]:w-full [&_iframe]:border-0 [&>div]:h-full [&>div]:w-full"
                />
            </div>
        </template>
    </base-drawer>
</template>
